import React from 'react';
import './CardComponent.css';

const CardComponent = ({ title, tourl, imgurl }) => {
    const getValidUrl = (url) => {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return `https://${url.trim()}`;
        }
        return url.trim();
    };

    const sanitizedUrl = getValidUrl(tourl);

    return (
        <a href={sanitizedUrl} target="_blank" rel="noopener noreferrer" className="company-slider-card">
            <div className="company-slider-card-img-container">
                <img src={imgurl} alt={title} className="company-slider-card-img" />
            </div>
            <div className="company-slider-card-title">{title}</div>
        </a>
    );
};

export default CardComponent;
